(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    let addedStateTimeout;
    let addSubmissionPending = false;

    const getDrawer = () => document.getElementById('cart-drawer');

    const setTitleState = (state) => {
      const drawer = getDrawer();

      if (!drawer) return;

      if (state === 'added') {
        drawer.dataset.ovahTitleState = 'added';
      } else {
        drawer.removeAttribute('data-ovah-title-state');
      }
    };

    const closeDrawerIfEmpty = (cart) => {
      const drawer = getDrawer();

      if (!drawer) return false;

      const cartIsEmpty = Number(cart?.item_count) === 0;
      const cartItems = Array.isArray(cart?.items) ? cart.items : null;
      const cartHasPaidItems = cartItems
        ? cartItems.some((item) => !String(item.handle || '').includes('docapp-free-gift'))
        : null;
      const paidLineItemExists = drawer.querySelector('.cart-drawer__items .line-item:not(.line-item--gift)');

      if (!cartIsEmpty && cartHasPaidItems !== false && paidLineItemExists) return false;

      const closeButton = drawer.shadowRoot?.querySelector('button[aria-label="Close"]');

      if (closeButton) closeButton.click();

      return true;
    };

    document.addEventListener('submit', (event) => {
      if (event.target.matches('form[action*="/cart/add"]')) {
        addSubmissionPending = true;
        window.setTimeout(() => {
          addSubmissionPending = false;
        }, 5000);
      }
    }, true);

    document.documentElement.addEventListener('cart:change', (event) => {
      const detail = event.detail || {};
      const isAddEvent = detail.baseEvent === 'variant:add' || addSubmissionPending;

      window.clearTimeout(addedStateTimeout);

      window.setTimeout(() => {
        if (closeDrawerIfEmpty(detail.cart)) {
          setTitleState('default');
          addSubmissionPending = false;
          return;
        }

        if (isAddEvent) {
          setTitleState('added');
          addedStateTimeout = window.setTimeout(() => setTitleState('default'), 2500);
        } else {
          setTitleState('default');
        }

        addSubmissionPending = false;
      }, 120);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
